module.exports = __webpack_public_path__ + "img/empilhadeiras_pag4.d5fa2869.jpg";